<template>
  <div>
    <top-header-info
      @checkEcPlatformPrices="checkEcPlatformPrices"
    ></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link
            style="color: #e33f4a"
            v-show="
              goodsInfo &&
                goodsInfo.category_tree &&
                goodsInfo.category_tree.length > 0
            "
            :to="{ name: 'index' }"
            >首页</router-link
          >

          <router-link
            v-show="
              goodsInfo &&
                goodsInfo.category_tree &&
                goodsInfo.category_tree.length > 0
            "
            v-for="item in goodsInfo.category_tree"
            :key="item.id"
            :to="{ name: 'products-list', query: { category_id: item.id } }"
          >
            <i class="el-icon el-icon-arrow-right" />
            <span style="color: #e33f4a">{{ item.name }}</span>
          </router-link>
        </div>
        <el-row class="goods-detail">
          <el-col :span="8">
            <div>
              <img class="big-img" :src="bigImgUrl || defaultGoods" alt />
            </div>
            <div class="swiper-img-wrap">
              <div class="swiper-img" ref="scrollImg">
                <i class="el-icon el-icon-arrow-left" @click="scrollToLeft"></i>
                <div
                  class="myPics"
                  v-for="(item, index) in images"
                  :key="index"
                  @mouseenter="showBigImg(item.image)"
                  @click="showBigImg(item.image)"
                >
                  <img :src="item.image || defaultGoods" alt="pics" />
                </div>
                <i
                  class="el-icon el-icon-arrow-right"
                  @click="scrollToRight"
                ></i>
              </div>
            </div>
          </el-col>
          <el-col :span="16" class="goods-texts">
            <h2>{{ goodsInfo.name }}</h2>
            <h3>{{ goodsInfo.name }}</h3>
            <el-row class="price-wrap">
              <el-col :span="18">
                <span class="special">{{ goodsInfo.special | jifen }}</span>
                <span class="discount-text" v-if="goodsInfo.dis_rate_text">{{
                  goodsInfo.dis_rate_text
                }}</span>
                <span
                  v-if="isFalse(goodsInfo.price, goodsInfo.special)"
                  style="text-decoration: line-through"
                  >{{ goodsInfo.price | jifen }}</span
                >
                ({{ goodsInfo.identify_type }})
              </el-col>
              <el-col
                :span="6"
                style="text-align: right"
                v-show="goodsInfo.show_evaluation"
              >
                <a
                  v-if="jdUrl && check_ec_platform_prices"
                  :href="jdUrl"
                  target="_blank"
                >
                  {{ goodsInfo.orig_url_text }}
                </a>
              </el-col>
            </el-row>
            <el-row class="goods-small-text">
              <el-col @click.native.stop="isShowSelectAddress = false">
                <span>编号</span>
                {{ goodsInfo.sku }}
              </el-col>
              <!-- <el-col @click.native.stop="isShowSelectAddress=false">
                <span>运费</span>
              </el-col>-->
              <el-col>
                <span>配送至</span>
                <div
                  class="address"
                  @click="isShowSelectAddress = !isShowSelectAddress"
                >
                  {{ address }}
                </div>
                <i
                  class="el-icon-arrow-down"
                  @click.stop="isShowSelectAddress = !isShowSelectAddress"
                  style="cursor: pointer"
                ></i>
                <address-tree
                  v-if="isShowSelectAddress"
                  @setAddress="setAddress"
                ></address-tree>
                <span style="text-align-last: right">
                  {{
                    goodsInfo.can_buy_status === 1
                      ? "有货"
                      : goodsInfo.can_buy_status_text
                  }}
                </span>
                <div
                  style="margin-left: 67px;margin-top: -10px;color:#999999;line-height: 24px;"
                  v-if="
                    goodsInfo.promise_tips && goodsInfo.can_buy_status === 1
                  "
                  v-html="goodsInfo.promise_tips"
                ></div>
              </el-col>
              <el-col
                v-show="goodsInfo.show_evaluation"
                @click.native.stop="isShowSelectAddress = false"
              >
                <span v-if="goodsInfo.tag">配送服务</span>
                <span
                  class="desc"
                  v-if="goodsInfo.tag && goodsInfo.tag.is_self_text"
                >
                  {{ goodsInfo.tag.is_self_text }}
                </span>
                <span
                  class="desc"
                  v-if="goodsInfo.tag && goodsInfo.tag.factory_ship_text"
                >
                  {{ goodsInfo.tag.factory_ship_text }}
                </span>
                <span
                  class="desc"
                  v-if="goodsInfo.tag && goodsInfo.tag.afterservice_text"
                >
                  {{ goodsInfo.tag.afterservice_text }}
                </span>
                <span
                  class="desc"
                  v-if="goodsInfo.tag && goodsInfo.tag.return_goods_text"
                >
                  {{ goodsInfo.tag.return_goods_text }}
                </span>
                <span class="desc" v-if="goodsInfo.free_shipping_text">
                  包邮
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="此商品免邮，与其他商品一起购可能产生运费。"
                    placement="top"
                    popper-class="product-tooltip"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </span>
              </el-col>
              <el-col
                class="Pos-r"
                v-show="goodsInfo.show_evaluation"
                @click.native.stop="isShowSelectAddress = false"
              >
                <span>商品好评</span>
                <div class="star-gray">
                  <div class="star-red" :style="{ width: commentRate }"></div>
                </div>
                <span>累计评价:</span>
                <span style="color: #236cac; text-align-last: left">{{
                  total
                }}</span>
              </el-col>
              <el-col
                @click.native.stop="isShowSelectAddress = false"
                style="display:flex;align-items: center;"
              >
                <span>数量</span>
                <el-input-number
                  v-model="number"
                  size="mini"
                  :min="minNum"
                  :max="maxNum"
                ></el-input-number>
                <div style="color:#EE0B24;margin-left:5px;font-size:12px">
                  {{ orderLimitText }}
                </div>
              </el-col>
              <el-col
                class="clearfix"
                v-for="item in goodsInfo.variant_option"
                :key="item.option_id"
                @click.native.stop="isShowSelectAddress = false"
              >
                <span class="Fl-l" style="margin-top: 10px"
                  >选择{{ item.name }}</span
                >
                <div class="specification">
                  <b
                    :class="{
                      actived: item.select_option_value == i.option_value_id,
                      disabled: i.disabled == true
                    }"
                    v-for="i in item.option_value"
                    :key="i.option_value_id"
                    @click="selectSpecification(item, i)"
                  >
                    <div>
                      <img :src="i.image" v-if="i.image" alt />
                      <span>{{ i.name }}</span>
                    </div>
                  </b>
                </div>
              </el-col>
            </el-row>
            <el-button
              @click="doBuyNow"
              :class="{
                'btn-disabled': goodsInfo.can_buy_status !== 1
              }"
              :disabled="goodsInfo.can_buy_status !== 1"
              >立即购买</el-button
            >
            <el-button
              @click="addToCart"
              :class="{ 'btn-disabled': goodsInfo.can_buy_status !== 1 }"
              :disabled="goodsInfo.can_buy_status !== 1"
              >加入购物车</el-button
            >
            <div v-if="goodsInfo.thwa">温馨提示：{{ goodsInfo.thwa }}</div>
            <div>
              本商城商品价格以实际下单为准。不参与京东、网易、苏宁、天猫等官网APP的任何价保、优惠、秒杀、满减、优惠券、促销、等活动。赠品赠完即止，具体以实际收货为准。不支持以旧换新等服务。商品一经售出，如遇价格变动，恕不支持退还差价。
            </div>
          </el-col>
        </el-row>
        <el-row
          class="goods-group"
          v-if="disCountList && disCountList.length > 0"
        >
          <div class="title">
            当前商品为组合商品，包含以下商品，将组合销售：
          </div>
          <div class="carousel">
            <i class="el-icon el-icon-arrow-left" @click="leftClick"></i>
            <div class="box">
              <div
                class="imgs"
                :style="
                  'transform: translateX(' +
                    tr +
                    'px);transition: all ' +
                    time +
                    's;'
                "
              >
                <div
                  class="img"
                  v-for="(item, index) in disCountList"
                  :key="index"
                  @click="goDetail(item)"
                >
                  <img :src="item.product.image || defaultGoods" alt />
                  <div class="name">{{ item.product.model }}</div>
                  <div class="special">{{ item.product.special | jifen }}</div>
                  <div class="group-num">X {{ item.quantity }} 份</div>
                </div>
              </div>
            </div>
            <i class="el-icon el-icon-arrow-right" @click="rightClick"></i>
          </div>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4" class="recommend-list">
            <p class="recommend-title" ref="scrollTopDistance">今日热销</p>
            <div
              v-for="item in [...goodsInfo]"
              :key="item.product_id"
              @click="goToGoosDetail(item.product_id)"
            >
              <div>
                <img :src="item.image" alt="goods" />
              </div>
              <div class="goods-description">{{ item.name }}</div>
              <el-row class="goods-price">
                <el-col :span="18" class="price">
                  {{ item.special | jifen }}
                  <span v-if="item.price_format < item.special_format">{{
                    item.price | jifen
                  }}</span>
                </el-col>
                <el-col :span="6">
                  <el-button @click.stop="addOther(item.product_id)">
                    <i class="el-icon el-icon-shopping"></i>
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="20" class="goods-images-description">
            <p>
              <span
                :class="{ actived: curIndex == 0 }"
                @click="
                  curIndex = 0;
                  clickScrollTop();
                "
                >商品详情</span
              >
              <span
                v-if="goodsInfo.param"
                :class="{ actived: curIndex == 2 }"
                @click="
                  curIndex = 2;
                  clickScrollTop();
                "
                >规格参数</span
              >
              <span
                v-show="goodsInfo.show_evaluation"
                :class="{ actived: curIndex == 1 }"
                @click="
                  curIndex = 1;
                  clickScrollTop();
                "
                >商品评价（{{ total }}）</span
              >
            </p>
            <div
              class="dommodity-attributeBox"
              v-show="
                curIndex == 0 &&
                  goodsInfo.category_attrs &&
                  goodsInfo.category_attrs.length > 0
              "
            >
              <div class="brandName" v-if="goodsInfo.brand_name">
                <span>品牌：</span><span>{{ goodsInfo.brand_name }}</span>
              </div>
              <ul class="dommodity-attribute">
                <li
                  v-for="(item, index) in goodsInfo.category_attrs"
                  :key="index"
                >
                  {{ item.attrName }}：{{ item.vals.join("，") }}
                </li>
              </ul>
              <div class="more" v-if="goodsInfo.param">
                <span
                  @click="
                    curIndex = 2;
                    clickScrollTop();
                  "
                  >更多参数&gt;&gt;</span
                >
              </div>
            </div>
            <div
              class="description"
              v-html="goodsInfo.description"
              v-show="curIndex == 0"
              style="padding-top:20px;"
            ></div>
            <div
              v-show="(curIndex == 0 || curIndex == 2) && goodsInfo.param"
              class="paramtable"
            >
              <div v-html="goodsInfo.param"></div>
              <table class="Ptable" width="100%">
                <tr>
                  <th class="tdTitle">包装清单</th>
                </tr>
                <tr></tr>
                <tr>
                  <td class="tdTitle">{{ goodsInfo.wareQD }}</td>
                </tr>
              </table>
            </div>
            <comment
              v-if="goodsInfo.product_id"
              :goodsInfo="goodsInfo"
              :comment_param="comment_param"
              v-show="
                (curIndex == 0 || curIndex == 1 || curIndex == 2) &&
                  goodsInfo.show_evaluation
              "
              @commentshow="commentshowstar"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import AddressTree from "@/components/address-tree";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import comment from "./comment.vue";
import { mixinUserbehv } from "@/assets/js/userbehv";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    AddressTree,
    comment
  },
  data() {
    return {
      goodsInfo: {},
      bigImgUrl: "",
      jdUrl: "",
      number: 1,
      minNum: 1,
      maxNum: undefined,
      commentRate: 0,
      product_id: this.$route.query.product_id,
      isShowSelectAddress: false,
      address: "",
      total: 0,
      curIndex: 0,
      disCountList: [],
      tr: 0,
      dis_num: 0,
      count: 0,
      time: 1,
      defaultGoods: DEFAULTGOODS,
      message: sessionStorage.getItem("activityMessage"),
      comment_param: {},
      start_stay_time: null,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      check_ec_platform_prices: false
    };
  },
  computed: {
    images: function() {
      let images = [];
      if (this.goodsInfo.images) {
        images = this.goodsInfo.images;
      } else {
        images.unshift({
          image: this.goodsInfo.image
        });
      }
      return images;
    },
    orderLimitText() {
      if (this.minNum > 1 && !this.maxNum) {
        return `(${this.minNum}件起售)`;
      } else if (this.maxNum > 1 && this.minNum == 1) {
        return `(最多可购买${this.maxNum}件)`;
      } else if (this.minNum > 1 && this.maxNum > 1) {
        return `(${this.minNum}件起售，最多可购买${this.maxNum}件)`;
      } else {
        return "";
      }
    }
  },
  mounted() {
    // this.setNumber();
    window.addEventListener("scroll", () => {
      this.scrollTop = window.scrollY;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll"); //离开当前组件别忘记移除事件监听哦
  },
  created() {
    this.getGoodsInfo();
    if (!this.$util.getLocalStorage("sbzRegion").sbzRegion) {
      let sbzRegion = {
        label: "上海 静安区 ",
        value: "2_2817_"
      };
      this.getAreaList(2817).then(res => {
        sbzRegion.label += res.name;
        sbzRegion.value += res.id;
        this.$util.setLocalStorage({
          sbzRegion: JSON.stringify(sbzRegion)
        });
        this.address = sbzRegion.label;
      });
    } else {
      this.address = JSON.parse(
        this.$util.getLocalStorage("sbzRegion").sbzRegion
      ).label;
    }
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          // console.log("滚动结束");
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
          this.setUserbehv(
            this.product_id,
            "stay",
            this.goodsInfo.sku,
            Math.floor((new Date().getTime() - this.start_stay_time) / 1000)
          );
        }
      }, 3000); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        // console.log("滚动开始");
        this.start_stay_time = new Date().getTime();
      }
    },
    $route() {
      this.product_id = this.$route.query.product_id;
      this.getGoodsInfo();
      // this.setNumber();
    }
  },
  mixins: [mixinUserbehv],
  methods: {
    checkEcPlatformPrices(val) {
      this.check_ec_platform_prices = val;
    },
    commentshowstar(e) {
      if (e) {
        this.commentRate = e + "%";
      } else {
        this.commentRate =
          parseFloat(
            (this.goodsInfo.product_comment_summary.good_rate * 100).toFixed(2)
          ) + "%";
      }
    },
    leftClick() {
      if (this.dis_num >= 0) {
        return;
      }
      this.dis_num++;
      this.tr = this.dis_num * 200;
    },
    rightClick() {
      if (this.dis_num + this.count <= 0) {
        return;
      }
      this.dis_num--;
      this.tr = this.dis_num * 200;
    },
    goDetail(item) {
      this.$router.push({
        name: "product-detail",
        query: {
          type: this.$route.query.type,
          product_id: item.product.product_id
        }
      });
    },
    isFalse(price, special) {
      let oPrice = parseFloat(price);
      let oSpecial = parseFloat(special);
      if (oPrice > oSpecial) {
        return true;
      }
      return false;
    },
    getGoodsInfo() {
      this.$reqGet("api/ecomm/product/" + this.product_id).then(async res => {
        this.goodsInfo = res.data.data;
        this.comment_param = this.goodsInfo.comment_param;
        this.minNum = this.goodsInfo.minimum || 1;
        this.maxNum =
          this.goodsInfo.maxnum > 0 ? this.goodsInfo.maxnum : undefined;
        this.number = this.minNum;
        this.jdUrl = this.goodsInfo.orig_url || false;
        if (
          this.goodsInfo.product_comment_summary &&
          this.goodsInfo.product_comment_summary.good_rate
        ) {
          this.commentRate =
            this.goodsInfo.product_comment_summary.good_rate * 100 + "%";
        }
        this.skuMap = this.goodsInfo.sku_map;
        this.disCountList = this.goodsInfo.group || [];
        this.count = this.disCountList.length - 5;
        if (
          this.goodsInfo.product_comment_summary &&
          this.goodsInfo.product_comment_summary.comment_count
        ) {
          this.total =
            this.goodsInfo.product_comment_summary.comment_count > 10000
              ? parseInt(
                  this.goodsInfo.product_comment_summary.comment_count / 10000
                ) + "万+"
              : this.goodsInfo.product_comment_summary.comment_count;
        }
        if (this.goodsInfo.variant_option) {
          this.variantOption = this.goodsInfo.variant_option || [];
          if (this.variantOption.length > 0) {
            this.updateAvailabeOptions(this.variantOption[0], {
              default: this.variantOption[0].select_option_value
            });
          }
        }
        this.bigImgUrl =
          this.goodsInfo.images && this.goodsInfo.images.length > 0
            ? this.goodsInfo.images[0].image
            : this.goodsInfo.image;
        if (this.goodsInfo.identify_type === "京东直供（满59元包邮）") {
          this.goodsInfo = { ...this.goodsInfo, ...this.goodsInfo.rt_meta };
          this.$reqGet(
            "api/ecomm/product/get_promise_tips/" + this.goodsInfo.sku,
            {
              minimum: this.goodsInfo.minimum,
              hideLoading: true
            }
          ).then(res => {
            if (res.data.success) {
              this.$set(
                this.goodsInfo,
                "promise_tips",
                res.data.data.promise_tips
              );
            }
          });
        }
      });
    },
    setNumber() {
      this.$reqGet("api/ecomm/product/" + this.product_id).then(res => {
        this.goodsInfo = res.data.data;
        this.minNum = this.goodsInfo.minimum;
        if (this.minNum === 0) {
          this.minNum = 1;
        }
        this.number = this.minNum;
      });
    },
    showBigImg(imgUrl) {
      this.bigImgUrl = imgUrl;
    },
    scrollToLeft() {
      let scrollLeft = this.$refs.scrollImg.scrollLeft;
      if (scrollLeft != 0) {
        this.$refs.scrollImg.scrollLeft -= 86;
      }
    },
    scrollToRight() {
      let scrollLeft = this.$refs.scrollImg.scrollLeft;
      if (scrollLeft <= 176) {
        this.$refs.scrollImg.scrollLeft += 86;
      }
    },
    setAddress(sbzRegion) {
      this.isShowSelectAddress = false;
      this.address = sbzRegion.label;
      this.$util.setLocalStorage({ sbzRegion: JSON.stringify(sbzRegion) });
      this.getGoodsInfo();
    },
    selectSpecification(item, i) {
      item.select_option_value = i.option_value_id;
      this.defaultSpecification = ";";
      // this.variantOption.map(item => {
      this.goodsInfo.variant_option.map(item => {
        this.defaultSpecification +=
          item.option_id + ":" + item.select_option_value + ";";
      });
      for (let key in this.skuMap) {
        if (key == this.defaultSpecification) {
          this.product_id = this.skuMap[key];
          this.getGoodsInfo();
          break;
        } else {
          this.product_id = "";
          this.updateAvailabeOptions(item, i);
        }
      }
    },
    isOptionValueInAvailableSkuMap(option, optionValue, sku_map) {
      var op_in_sku = false,
        selected_option = option.option_id + ":" + optionValue.option_value_id;
      sku_map.forEach(function(sm) {
        if (sm.indexOf(selected_option) != -1) {
          op_in_sku = true;
        }
      });
      return op_in_sku;
    },
    updateAvailabeOptions(option, optionValue) {
      var selected_options;
      if (typeof optionValue == "object" && optionValue.default) {
        selected_options = [option.option_id + ":" + optionValue.default];
      } else {
        selected_options = [
          option.option_id + ":" + optionValue.option_value_id
        ];
      }
      let sku_map = [];
      for (let b in this.skuMap) {
        sku_map.push(b.split(";"));
      }
      let that = this;
      sku_map = this.getAvailableSkuMap(selected_options, sku_map);
      this.variantOption.forEach(function(vo) {
        if (vo.option_id != option.option_id) {
          vo.option_value.forEach(function(ov) {
            if (!that.isOptionValueInAvailableSkuMap(vo, ov, sku_map)) {
              that.$set(ov, "disabled", true);
              if (ov.option_value_id == vo.select_option_value) {
                vo.select_option_value = 0;
              }
            } else {
              that.$set(ov, "disabled", false);
            }
          });
          if (vo.select_option_value != 0) {
            selected_options.push(vo.option_id + ":" + vo.select_option_value);
            sku_map = that.getAvailableSkuMap(selected_options, sku_map);
          }
        }
      });

      sku_map = [];
      selected_options.shift();
      for (let b in this.skuMap) {
        sku_map.push(b.split(";"));
      }
      sku_map = that.getAvailableSkuMap(selected_options, sku_map);
      this.variantOption.forEach(function(vo) {
        if (vo.option_id == option.option_id) {
          vo.option_value.forEach(function(ov) {
            if (!that.isOptionValueInAvailableSkuMap(vo, ov, sku_map)) {
              that.$set(ov, "disabled", true);
            } else {
              that.$set(ov, "disabled", false);
            }
          });
        }
      });
    },

    getAvailableSkuMap(selected_options, sku_map) {
      var op_in_sku = true,
        sku_map2 = [];
      sku_map.map(function(sm) {
        op_in_sku = true;
        selected_options.map(function(so) {
          if (sm.indexOf(so) == -1) {
            op_in_sku = false;
          }
        });
        if (op_in_sku) {
          sku_map2.push(sm);
        }
      });
      return sku_map2;
    },
    addToCart(showToast = true) {
      if (this.message) {
        this.$alert(this.message, "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.product_id) {
        return this.$reqPost("api/store/cart", {
          id: this.product_id,
          qty: this.number
        }).then(res => {
          if (res.data.status == 200) {
            if (showToast) {
              this.setUserbehv(this.product_id, "cart", this.goodsInfo.sku, 1);
              this.open();
              this.$bus.emit("get-cartNum");
            }
          }
        });
      } else {
        this.$message.error("请选择商品规格");
        return;
      }
    },
    // 暂未开放该功能，先注释掉
    addOther(id) {
      console.log(id);
      // return this.$reqPost("api/store/cart", {
      //   id: id,
      //   qty: 1
      // }).then(res => {
      //   if (res.data.status == 200) {
      //     this.open();
      //     this.$bus.emit("get-cartNum");
      //   }
      // });
    },
    open() {
      this.$message({ message: "添加至购物车成功", type: "success" });
    },
    async doBuyNow() {
      if (this.message) {
        this.$alert(this.message, "提示", {
          confirmButtonText: "确定"
        });
        return;
      } else {
        this.setUserbehv(this.product_id, "buy", this.goodsInfo.sku, 1);
        await this.addToCart(false);
        if (this.product_id) {
          this.$reqPost("api/store/cart/checkall", { check: 0 }).then(() => {
            this.$reqPut("api/store/cart/" + this.product_id, {
              qty: this.number
            }).then(() => {
              this.$reqPost("api/store/cart/check/" + this.product_id, {
                check: 1
              }).then(() => {
                this.$router.push({ name: "check-order" });
              });
            });
          });
        }
      }
    },
    goToGoosDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/productDetail",
        query: { type: this.$route.query.type, product_id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    clickScrollTop() {
      let distance =
        this.getElementToPageTop(this.$refs.scrollTopDistance) - 400;
      if (distance < document.documentElement.scrollTop) {
        document.documentElement.scrollTop = distance;
      }
    },
    getElementToPageTop(el) {
      if (el.parentElement) {
        return this.getElementToPageTop(el.parentElement) + el.offsetTop;
      }
      return el.offsetTop;
    },
    async getAreaList(city) {
      return await this.$reqGet("api/store/address/area_list/" + city).then(
        res => {
          return res.data.data[0];
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ssd-module-wrap .ssd-widget-circle,
/deep/ .ssd-module-wrap .ssd-widget-line,
/deep/ .ssd-module-wrap .ssd-widget-pic,
/deep/ .ssd-module-wrap .ssd-widget-rectangle,
/deep/ .ssd-module-wrap .ssd-widget-table,
/deep/ .ssd-module-wrap .ssd-widget-text,
/deep/ .ssd-module-wrap .ssd-widget-triangle {
  color: #333;
  position: static !important;
  overflow: visible !important;
  font-size: 12px;
}
/deep/ .ssd-module,
.ssd-module-heading {
  font-size: 12px;
}
.site-nav {
  padding: 20px 0;
  // color: #999;
  font-size: 16px;
}
.goods-detail {
  padding: 10px;
  background-color: #fff;
  .el-col:first-child {
    > div:first-child {
      padding-left: 13px;
      .big-img {
        width: 360px;
      }
    }
    .swiper-img-wrap {
      position: relative;
      height: 85px;
      overflow: hidden;
      margin-top: 20px;
      padding: 0 20px;

      i {
        position: absolute;
        top: 40%;
        font-size: 20px;
        color: #bcbcbc;
      }
      i:first-child {
        left: -6px;
      }
      i:last-child {
        right: 0px;
      }
    }
    .swiper-img {
      height: 100px;
      overflow: hidden;
      white-space: nowrap;
      overflow-x: scroll;
      .myPics {
        width: 80px;
        height: 80px;
        border: 1px solid #dadada;
        display: inline-block;
        margin-right: 6.5px;
        &:hover {
          border: 1px solid #eb000e;
          border-radius: 3px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .goods-texts {
    padding-left: 20px;
    h2 {
      font-size: 24px;
      color: #000;
      margin: 0;
    }
    h3 {
      font-weight: normal;
      color: #fd6c17;
      font-size: 16px;
      margin: 8px 0;
    }
    .price-wrap {
      background-color: #eee;
      color: #999;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      .special {
        color: #eb000e;
        font-size: 24px;
        margin-right: 10px;
      }

      // .el-col:first-letter {
      //   font-size: 16px;
      // }
      a {
        color: #1b6cab;
      }
    }
    .goods-small-text {
      line-height: 40px;
      color: #222;
      min-height: 234px;
      > div > span {
        color: #999;
        display: inline-block;
        // width: 64px;
        text-align-last: justify;
        margin-right: 20px;
      }
      .star-gray {
        position: relative;
        top: 5px;
        width: 120px;
        height: 24px;
        display: inline-block;
        background-image: url("../../assets/images/star_g.png");
        background-repeat: repeat-x;
        margin-right: 20px;
        .star-red {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          background-image: url("../../assets/images/star_r.png");
          background-repeat: repeat-x;
        }
      }
      .el-input,
      .el-input__inner {
        height: 28px;
        line-height: 28px;
        border-radius: 0;
        // border: none !important;
      }

      .el-input-number {
        height: 26px;
        line-height: 26px;
        margin-left: -5px;
      }
      .specification {
        display: inline-block;
        width: calc(100% - 120px);
      }
      b {
        display: inline-block;
        height: 45px;
        text-align: center;
        font-weight: normal;
        background: rgba(255, 255, 255, 1);
        border: 1px solid #dadada;
        padding: 0 10px;
        margin: 10px 10px 0 0;
        cursor: pointer;
        &.actived {
          border: 1px solid rgba(252, 0, 16, 1);
        }
        div {
          display: flex;
          align-items: center;
          line-height: 45px;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .disabled {
        border: 1px dashed #aaa;
        background-color: #f0f0f0;
      }
    }
    .address {
      display: inline-block;
      width: auto;
      cursor: pointer;
    }
    .el-button {
      width: 180px;
      height: 45px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(226, 51, 63, 1);
      border-radius: 5px;
      font-size: 18px;
      color: #e2333f;
      margin: 10px 10px 10px 0;
    }
    .el-button:last-of-type {
      background: rgba(226, 51, 63, 1);
      color: #fff;
    }
  }
}
.btn-kf {
  width: 180px;
  height: 45px;
  background: #fff !important;
  border: none !important;
  border-radius: 5px;
  font-size: 18px;
  color: #e2333f !important;
  margin: 10px 10px 10px 0;
}
.btn-kf:last-of-type {
  background: none;
  color: #fff;
}
.goods-group {
  height: 390px;
  background: #fff;
  margin-top: 20px;
  > .title {
    color: #333333;
    font-weight: bold;
    padding: 20px;
  }
  .carousel {
    display: flex;
    align-items: center;
    .box {
      position: relative;
      overflow: hidden;
      margin: 0 auto;
      width: 1000px;
      height: 300px;
      .imgs {
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        width: 200px;
        box-sizing: border-box;
        .img {
          float: left;
          width: 194px;
          position: relative;
          margin: 0 3px;
          cursor: pointer;
          img {
            border: 1px solid #e4e4e4;
            width: 194px;
            height: 200px;
            box-sizing: border-box;
            transition: 1s;
          }
          .name {
            margin-top: 10px;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .special {
            font-size: 18px;
            color: #dd4545;
            margin-top: 10px;
          }
          .group-num {
            position: absolute;
            top: 0;
            right: 0;
            padding: 3px 5px;
            background: #8e8e8e;
            color: #fff;
          }
        }
      }
    }
    .el-icon {
      cursor: pointer;
      font-size: 30px;
      padding: 20px;
      color: #999;
    }
  }
}

.btn-disabled {
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #efefef !important;
  border-color: #ddd !important;
}
.recommend-title {
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: rgba(245, 245, 245, 1);
  border: 1px solid rgba(205, 205, 205, 1);
  margin-bottom: 0;
}
.recommend-list {
  > div {
    cursor: pointer;
    background-color: #fff;
    border: 1px solid #eee;
    text-align: center;
    &:hover {
      box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.2);
    }
    img {
      width: 150px;
      height: 150px;
      padding: 10px 0;
    }
    .goods-description {
      line-height: 21px;
      text-align: left;
      color: #000;
      height: 42px;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding: 0 10px;
    }
    .goods-price {
      line-height: 20px;
      color: #e2333f;
      font-size: 18px;
      padding: 0 10px 10px;
      line-height: 36px;
      white-space: nowrap;
      // .el-col:first-letter {
      //   font-size: 14px;
      // }
      .price {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        font-size: 14px;
        color: #666;
        text-decoration: line-through;
      }

      .el-col:last-child {
        text-align: right;
        .el-button {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          line-height: 34px;
          text-align: center;
          padding: 0;
          background-color: #e2333f;
          border: none;
          .el-icon {
            color: #fff;
            font-size: 18px;
          }
        }
      }
    }
  }
}
.goods-images-description {
  margin-top: 15px;
  // font-size: 0;
  > p:first-child {
    margin: 0;
    position: sticky;
    top: 0px;
    z-index: 999;
    height: 40px;
    line-height: 40px;
    background: #f5f5f5;
    border: 1px solid #e4e4e4;
    color: #666666;
    span {
      display: inline-block;
      width: 214px;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      padding: 0;
      cursor: pointer;
      &.actived {
        color: #fff;
        background: #e2343f;
      }
    }
  }

  > div:nth-child(2) {
    padding: 15px;
  }
  > div {
    background-color: #fff;
    border: 1px solid #cdcdcd;
    border-top: none;
  }
  .dommodity-attributeBox {
    .dommodity-attribute {
      position: relative;
      li {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        margin-bottom: 5px;
      }
    }
    .more {
      font-size: 12px;
      font-weight: 400;
      color: #1b6cab;
      display: flex;
      justify-content: flex-end;
      span {
        cursor: pointer;
      }
    }
    .brandName {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 5px;
      span:nth-child(2) {
        color: #1b6cab;
      }
    }
  }
}
.formwork_bt {
  overflow: hidden;
  width: 753px;
  padding: 10px 0;
  line-height: 23px;
  text-align: left;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
  span {
    font-size: 18px;
    color: #c90014;
    padding-left: 2px;
    padding-top: 12px;
  }
  .s2 {
    color: #666;
    padding-left: 10px;
    line-height: 25px;
    padding-top: 16px;
    font-size: 12px;
  }
}
.formwork .formwork_text {
  font-size: 14px;
}

.after-comment {
  color: #999;
  font-size: 12px;
  padding: 5px 0;
}
video {
  margin-top: 10px;
}
.address /deep/ .el-input__inner {
  border: none;
  height: 28px;
  line-height: 28px;
  border-radius: 0;
  padding: 0;
  cursor: pointer;
}
.description {
  /deep/ p {
    margin: 0;
    img {
      display: block;
    }
  }
}
.paramtable {
  font-size: 16px;
  padding: 20px;
}
// .paramtable /deep/.Ptable {
//   // border: 1px solid #ddd;
//   border-collapse: collapse;
//   padding: 0;
//   // table-collapse: collapse;
//   th {
//     height: 40px;
//     line-height: 40px;
//     background-color: #ddd;
//     text-align: left;
//     padding-left: 30px;
//     border: 1px solid #ddd;
//   }
//   td {
//     height: 40px;
//     line-height: 40px;
//     border: 1px solid #ddd;
//     padding-left: 30px;
//   }
// }
.paramtable /deep/.Ptable {
  width: 844px;
  margin-left: 110px;
  tr {
    position: relative;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    text-align: right;
    display: flex;
    align-items: start;
    line-height: 30px;
    td {
      position: relative;
      &:nth-child(1) {
        min-width: 165px;
        margin-right: 48px;
      }
      &:nth-child(2) {
        text-align: left;
      }

      .Ptable-tips {
        position: absolute;
        right: -16px;
        top: 0;
        a:hover + .tips {
          display: block;
        }
        .Ptable-sprite-question {
          &:before {
            content: "?";
            font-style: normal;
            position: relative;
            color: #999999;
            top: -8px;
            left: -2px;
          }
          border-radius: 50%;
          display: inline-block;
          width: 12px;
          height: 12px;
          border: 1px solid #999999;
        }
        .tips {
          display: none;
          background: #fff;
          z-index: 1;
          position: relative;
          box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
          right: -250px;
          top: -20px;
          width: 300px;
          text-align: left;
          border-radius: 2px;
          padding: 0 10px;
        }
        a {
          position: relative;
          top: 7px;
        }
      }
    }
    th {
      position: absolute;
      width: 110px;
      left: -120px;
      padding-right: 840px;
      border-top: 1px solid #f5f5f5;
      top: 0;
      font-weight: normal;
    }
  }
}
.discount-text {
  margin: 0 5px;
  padding: 2px 4px;
  color: #fff;
  background: #f0484a;
  border-radius: 2px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/detail.vue